export default __webpack_public_path__ + "static/media/life01.239a693b.png";